<template>
    <div class="main-container bg-gray" id="container">
        <div class="overlay"></div>
        <div class="search-overlay"></div>
        <Left />
        <Right>
            <Dashboard v-if="currentRouteName === 'dashboard'"></Dashboard>

            <PropertyOwner v-if="currentRouteName === 'property-owners'"></PropertyOwner>
            <UserProfile v-if="currentRouteName === 'view-user-profile'"></UserProfile>
            <PropertyOwnerView v-if="currentRouteName === 'property-owners-view'"></PropertyOwnerView>
            <PropertySubAmin v-if="currentRouteName === 'property-owners-sub-admin'"></PropertySubAmin>
            <PropertyResidents v-if="currentRouteName === 'property-residents'"></PropertyResidents>
            <PropertyOnwerResidents v-if="currentRouteName === 'property-owners-residents'"></PropertyOnwerResidents>

            <PropertyManager v-if="currentRouteName === 'property-manager'"></PropertyManager>
        </Right>
    </div>
</template>

<script>
import Left from './Left';
import Right from './Right';
import Dashboard from '../Accounts/Dashboard';

//Property owner
import PropertyOwner from '../Accounts/PropertyOwner/index';
import UserProfile from '../Accounts/UserProfile';
import PropertyOwnerView from '../Accounts/PropertyOwner/Property';
import PropertySubAmin from '../Accounts/PropertyOwner/PropertySubAmin';
import PropertyOnwerResidents from '../Accounts/PropertyOwner/PropertyResidents';

import PropertyManager from '../Accounts/PropertyManager';
import PropertyResidents from '../Accounts/PropertyResidents';

export default {
    components: { 
        Left,
        Right,
        Dashboard,
        PropertyOwner,
        PropertyManager,
        PropertyResidents,
        UserProfile,
        PropertyOwnerView,
        PropertySubAmin,
        PropertyOnwerResidents,
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    }
}
</script>

<style scoped>
.bg-gray {
    background: #f1f2f3;
}

</style>